var React = require('react');

function FilterIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"1.78516","width":"18","height":"1.42857","rx":"0.714286","fill":"#E1656E","key":0}),React.createElement("rect",{"y":"6.78613","width":"18","height":"1.42857","rx":"0.714286","fill":"#E1656E","key":1}),React.createElement("rect",{"y":"11.7852","width":"18","height":"1.42857","rx":"0.714286","fill":"#E1656E","key":2}),React.createElement("ellipse",{"cx":"4.32029","cy":"2.5","rx":"2.52","ry":"2.5","fill":"#E1656E","key":3}),React.createElement("ellipse",{"cx":"13.3198","cy":"7.5","rx":"2.52","ry":"2.5","fill":"#E1656E","key":4}),React.createElement("ellipse",{"cx":"6.11961","cy":"12.5","rx":"2.52","ry":"2.5","fill":"#E1656E","key":5})]);
}

FilterIcon.defaultProps = {"width":"18","height":"15","viewBox":"0 0 18 15","fill":"none"};

module.exports = FilterIcon;

FilterIcon.default = FilterIcon;
